<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="数据汇总"
                name="1"
                link="/report/channel/channelReport/reportList"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/report/channel/visitDetailList')"
                label="访问明细"
                name="2"
                link="/report/channel/accessDetails/list"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/report/channel/channelList')"
                label="渠道管理"
                name="3"
                link="/report/channel/channelList"
            ></el-tab-pane>
			<el-tab-pane
			    v-if="$utils.have('/report/channel/channelTrack')"
			    label="渠道跟踪"
			    name="4"
			    link="/report/channel/channelTrack"
			></el-tab-pane>
			<el-tab-pane			    
			    label="快链数据"
			    name="5"
			    link="/report/channel/channelReport/linkList"
			></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>